import { render, staticRenderFns } from "./page-data-detail.vue?vue&type=template&id=0d27c64c&scoped=true&"
import script from "./page-data-detail.vue?vue&type=script&lang=js&"
export * from "./page-data-detail.vue?vue&type=script&lang=js&"
import style0 from "./page-data-detail.vue?vue&type=style&index=0&id=0d27c64c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d27c64c",
  null
  
)

export default component.exports